<template>
  <!-- 付款记录 -->
  <div class="payment-list">
    <ab-list-query :tabs="tabs" @handleTabs="handleTabs">
      <template #right>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              placeholder="来源单号"
              v-model.trim="formSearch.clientNumber"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <el-select
              placeholder="费用类型"
              v-model="formSearch.arType"
              clearable
              @change="searchForm"
            >
              <el-option
                v-for="option in options.arType"
                :key="option.value"
                :label="option.desc"
                :value="option.value"
              />
            </el-select>
          </el-col>
          <!-- <el-col :span="4">
            <el-select
              placeholder="单据类型"
              v-model="formSearch.xxx"
              clearable
            >
              <el-option
                label="待提交"
                value="40"
              ></el-option>
            </el-select>
          </el-col> -->
          <el-col :span="4">
            <ab-timeSearch
              class="searchBox"
              startSrc="发生日期起"
              endSrc="发生日期止"
              v-model="formSearch.bizDateArray"
              @searchEvent="bizDateChange"
            ></ab-timeSearch>
          </el-col>
          <el-col
            :span="4"
            class="text-left"
          >
            <el-button @click="searchForm">搜索</el-button>
            <el-button
              link
              class="btn-svg"
              @click="resetForm"
            >
              <ab-svg name="qingchu"></ab-svg>清除
            </el-button>
          </el-col>
        </el-row>
      </template>

      <template #toolbar>
        <el-button
          type="primary"
          :loading="loading.send"
          @click="billSend()"
          :disabled="multiSelected.length !== 1"
        >账单发财务</el-button>
      </template>

      <template #table>
        <ab-table
          class="materialTable"
          ref="table"
          stripe
          showEdit
          showSelection
          showMoreEdit
          selectionWidth="45"
          indexWidth="50"
          widths="190"
          isFilter="operator"
          :column-list="columns"
          :table-list="tableData"
          :dataListLoading="loading.table"
          :handleSelectionChange="selectionChange"
          @filterColumns="filterColumns"
        >
          <template #payStatusDesc="scope">
            <span :class="getStatusClass(scope.row.payStatus)"></span>
            {{ scope.row.payStatusDesc }}
          </template>

          <template #operator="scope">
            <el-button
              type="text"
              v-if="scope.row.payStatus != 1"
              :loading="loading.pay"
              link
              @click="handlerPay(scope.row)"
            >已支付</el-button>

            <el-button
              v-else
              type="text"
              link
              @click="copyNumber(scope.row.clientNumber)"
            >复制单号</el-button>
          </template>

          <template #moreOper="scope">
            <el-button
              v-if="scope.row.payStatus != 1"
              type="text"
              link
              @click="copyNumber(scope.row.clientNumber)"
            >复制单号</el-button>

            <el-button
              v-else
              type="text"
              :disabled="scope.row.payStatus == 1"
              :loading="loading.pay"
              link
              @click="handlerPay(scope.row)"
            >已支付</el-button>

            <el-button
              type="text"
              link
              @click="viewWaterBill(scope.row, true)"
            >上传水单</el-button>
          </template>
        </ab-table>
      </template>

      <template #page>
        <ab-page
          :pageTotal="page.total"
          :currentPage="page.currentPage"
          :pageSize="page.pageSize"
          :pageSizes="page.pageSizes"
          @searchForm="pageSearch"
        ></ab-page>
      </template>
    </ab-list-query>

    <ab-upload-once :params="uploadParams"></ab-upload-once>
    <textarea class="copy-text" id="copyText"></textarea>
  </div>
</template>

<script>
export default {
  name: 'payable-list',
  data() {
    return {
      tabs: [
        { name: '全部', value: '', state: '' },
        { name: '待支付', value: '', state: '0' },
        { name: '已支付', value: '', state: '1' }
      ],
      activedName: '',
      options: {},
      loading: {
        table: false,
        send: false,
        pay: false
      },
      formSearch: {},
      columns: [
        {
          props: 'clientNumber',
          labels: '来源单号',
          widths: 170
        },
        {
          props: 'bizDate',
          labels: '发生时间',
          widths: 170
        },
        {
          props: 'payStatusDesc',
          labels: '付款状态',
          widths: 90,
          slot: 'slot'
        },
        {
          props: 'sourceBillTypeDesc',
          labels: '单据类型',
          widths: 90
        },
        {
          props: 'arAmount',
          labels: '申请金额',
          widths: 100,
          type: 'money',
          align: 'right'
        },
        {
          props: 'currencyIdDesc',
          labels: '币别',
          widths: 80
        },
        // {
        //   props: 'xxx',
        //   labels: '申请金额',
        //   widths: 100,
        //   type: 'money',
        //   align: 'right'
        // },
        {
          props: 'arTypeDesc',
          labels: '费用类型',
          widths: 80
        }
      ],
      //列表数据
      tableData: [],
      // 勾选行
      multiSelected: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        total: 0
      },
      uploadParams: {
        sourceBillId: '',
        sourceBillNumber: '',
        sourceBillType: 'ReceiptMatching',
        show: false,
        items: [
          {
            title: '客户水单',
            attachType: '010',
            size: 5,
            message: '附件大小限制在5MB以内！'
          },
        ],
      }
    }
  },

  computed: {

  },

  created() {
    this.getSelectList()
  },
  activated () {
    this.searchForm()
  },
  methods: {
    getSelectList() {
      this.$get('/sms/client/receiptMatching/getSelect').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.options = data.result
        } else {
          this.options = {}
        }
      })
    },

    handleTabs(item) {
      this.activedName = item
      this.searchForm()
    },

    bizDateChange(value) {
      if (value) {
        this.formSearch.bizDateStart = value[0]
        this.formSearch.bizDateEnd = value[1]
      } else {
        this.formSearch.bizDateStart = ''
        this.formSearch.bizDateEnd = ''
      }
      this.searchForm()
    },

    filterColumns(array) {
      this.columns = array
    },

    searchForm() {
      this.page.currentPage = 1
      this.getListData()
    },

    resetForm() {
      this.formSearch = {}
    },

    pageSearch(obj) {
      this.page.currentPage = obj.currentPage
      this.page.pageSize = obj.pageSize
      this.getListData()
    },

    getListData() {
      let params = Object.assign({}, this.formSearch)
      params.payStatus = this.activedName
      this.$post('/sms/client/receiptMatching/list', {
        data: params,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }, this.loading, 'table').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.tableData = data.result.list
          this.page.total = data.result.total
          this.tabs.forEach(e => {
            if (e.name === '待支付') {
              e.value = data.extra && data.extra.unPaidNum || 0
            } else if (e.name === '已支付') {
              e.value = data.extra && data.extra.paidNum || 0
            }
          })
        }
      })
    },

    selectionChange(array) {
      this.multiSelected = array
    },

    getStatusClass(value) {      
      if (value === 1) { // 已支付
        return 'status-0AB2A8'
      } else {
        return 'status-E21010'
      }
    },

    // 账单发送财务
    billSend() {
      let finEmail = window.localStorage.getItem('finEmail')
      this.$prompt('', '账单发财务', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: finEmail,
        inputPlaceholder: '请输入电子邮箱',
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        this.$post('/sms/client/receiptMatching/billSendFinBiz', {
          id: this.multiSelected[0].id,
          finEmail: value
        }, this.loading, 'send').then(({ data }) => {
          if(data.code === 'C0000') {
            this.$message({
              type: 'success',
              message: data.message,
              offset: 380,
              grouping: true
            })
            window.localStorage.setItem('finEmail', value)
          }
        })
      }).catch(() => {})
    },

    // 已支付
    handlerPay(row) {
      this.loading.pay = true
      this.$get('/sms/client/receiptMatching/toPay', { id: row.id }).then(({ data }) => {
        if (data.code === 'C0000') {
          this.$message({
            type: 'success',
            message: '操作成功！',
            offset: 380,
            grouping: true
          })
          this.searchForm()
        }
      }).finally(() => {
        setTimeout(() => {
          this.loading.pay = false
        }, 500)
      })
    },

    // 复制单号
    copyNumber(text) {      
      const input = document.getElementById('copyText')  // 找到虚拟的输入框
      input.value = text // 修改文本框的内容
      input.select() // 选中文本
      document.execCommand('copy') // 执行浏览器复制命令
      this.$message({
        type: 'success',
        message: '复制成功!',
        offset: 380,
        grouping: true
      })
    },

    // 上传水单
    viewWaterBill(row) {
      this.uploadParams.sourceBillId = row.id
      this.uploadParams.show = true
    }
  }
}
</script>

<style lang="scss">
.payment-list {
  .el-table-fixed-column--right {
    .el-button + .el-button {
      position: relative;
      margin-left: 14px !important;
      &::before {
        content: '';
        position: absolute;
        left: -8px;
        top: 4px;
        width: 1px;
        height: 10px;
        background: #bfbfbf;
      }
    }
  }
}
</style>
